import React from "react";

const Checkbox = ({ amount, label, className = "", labelClassName = "" }) => {
  return (
    <label className={`flex items-center gap-2 ${className}`}>
      <input type="checkbox" className="" />
      <span
        className={`mt-[1px] font-pop text-xs font-normal text-darkGreen opacity-60 ${labelClassName}`}
      >
        {label} &nbsp; &nbsp; {amount && <span>({amount})</span>}
      </span>
    </label>
  );
};

export default Checkbox;
